export const Shop = {
    path: '/shop',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/shop/shop-index').default);
        }, 'Shop')
    }
};
export const ShopPage = {
    path: '/shop/page',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/shop/shop-index').default);
        }, 'ShopPage')
    }
};
export const GoodsList = {
    path: '/shop/GoodsList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-list').default);
        }, 'GoodsList')
    }
};
export const GoodsDetail = {
    path: '/shop/GoodsDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-detail').default);
        }, 'GoodsDetail')
    }
};
export const GoodsSearch = {
    path: '/shop/GoodsSearch',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-search').default);
        }, 'GoodsSearch')
    },
};
export const GoodsMessage = {
    path: '/shop/GoodsMessage',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-message').default);
        }, 'GoodsMessage')
    },
};
export const GoodsSearchResult = {
    path: '/shop/GoodsSearchResult',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-search-result').default);
        }, 'GoodsSearchResult')
    },
};
export const GoodsListLabel = {
    path: '/shop/GoodsListLabel',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-list-label').default);
        }, 'GoodsListLabel')
    },
};
export const GoodsPromotionList = {
    path: '/shop/GoodsPromotionList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-promotion-list').default);
        }, 'GoodsPromotionList')
    },
};
export const GoodsPackageList = {
    path: '/shop/GoodsPackageList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-package-list').default);
        }, 'GoodsPackageList')
    },
};
export const GoodsPackageDetail = {
    path: '/shop/GoodsPackageDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-package-detail').default);
        }, 'GoodsPackageDetail')
    },
};
export const CartList = {
    path: '/shop/CartList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/cart/cart-list').default);
        }, 'CartList')
    }
};


export const CartOrderPlatform = {
    path: '/shop/CartOrderPlatform',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/cart/cart-order-platform').default);
        }, "CartOrderPlatform")
    }
};

export const CartOrder = {
    path: '/shop/CartOrder',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/cart/cart-order').default);
        }, "CartOrder")
    }
};
export const OrderCreateResult = {
    path: '/shop/OrderCreateResult',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-create-result').default);
        }, "OrderCreateResult")
    }
};
export const cartPresaleOrder = {
    path: '/shop/cartPresaleOrder',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/cart/cart-presale-order.js').default);
        }, "cartPresaleOrder")
    }
};
export const OrderPay = {
    path: '/shop/OrderPay',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-pay').default);
        }, "OrderPay")
    }
};

export const OrderList = {
    path: '/shop/OrderList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-list'));
        }, "OrderList")
    }
};
export const OrderBatchPay = {
    path: '/shop/OrderBatchPay',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-batch-pay'));
        }, "OrderBatchPay")
    }
};
export const OrderDetail = {
    path: '/shop/OrderDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-detail'));
        }, "OrderDetail")
    }
};

/*我的*/
export const UserInfo = {
    path: '/shop/UserInfo',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-info'));
        }, "UserInfo")
    }
};
export const UserAddress = {
    path: '/shop/UserAddress',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-address').default);
        }, "UserAddress")
    }
};
export const UserAddressEdit = {
    path: '/shop/UserAddressEdit',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-address-edit').default);
        }, "UserAddressEdit")
    }
};
export const UserSetting = {
    path: '/shop/UserSetting',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-setting').default);
        }, "UserSetting")
    }
};

export const MyCollect = {
    path: '/shop/MyCollect',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/my-collect').default);
        }, 'MyCollect')
    }
};
export const KeepList = {
    path: '/shop/KeepList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/keep-list').default);
        }, 'KeepList')
    }
};

export const UserSupplier = {
    path: '/shop/UserSupplier',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-supplier'));
        }, "UserSupplier")
    }
};
export const UserAbout = {
    path: '/shop/UserAbout',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-about'));
        }, "UserAbout")
    }
};
export const User = {
    path: '/shop/User',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user').default);
        }, "User")
    }
};
export const GoodsProperty = {
    path: '/shop/GoodsProperty',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-property').default);
        }, "GoodsProperty")
    }
};

export const ShopError = {
    path: '/shop/ShopError',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/shop/shop-error').default);
        }, "ShopError")
    }
};
export const JumpError = {
    path: '/shop/JumpError',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/shop/jump-error').default);
        }, "JumpError")
    }
};
export const ShopNotice = {
    path: '/shop/ShopNotice',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/shop/shop-notice').default);
        }, "ShopNotice")
    }
};
export const NoticeDetail = {
    path: '/shop/NoticeDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/shop/notice-detail').default);
        }, "NoticeDetail")
    }
};
export const OrderMessage = {
    path: '/shop/OrderMessage',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/order-message').default);
        }, "OrderMessage")
    }
};
export const PaySuccess = {
    path: '/shop/PaySuccess',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/pay-success').default);
        }, "PaySuccess")
    }
};
export const OtherPaySuccess = {
    path: '/shop/OtherPaySuccess',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/otherPay-success').default);
        }, "OtherPaySuccess")
    }
};


export const UserBing = {
    path: '/shop/UserBing',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-bing-one').default);
        }, "UserBing")
    }
};
export const UserBingTwo = {
    path: '/shop/UserBingTwo',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-bing-two').default);
        }, "UserBingTwo")
    }
};

export const GoodsClassifyFilter = {
    path: '/shop/GoodsClassifyFilter',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-classify-filter').default);
        }, "GoodsClassifyFilter")
    }
};
export const GoodsGroupClassifyFilter = {
    path: '/shop/GoodsGroupClassifyFilter',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-group-classify').default);
        }, "GoodsGroupClassifyFilter")
    }
};
export const GoodsBrandList = {
    path: '/shop/GoodsBrandList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods/goods-brand-list').default);
        }, "GoodsBrandList")
    }
};
export const CouponList = {
    path: '/shop/CouponList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/coupon-list').default);
        }, "CouponList")
    }
};
export const ReceiveCoupon = {
    path: '/shop/ReceiveCoupon',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/receive-coupon').default);
        }, "ReceiveCoupon")
    }
};
// 对账结算列表
export const SettleAccountsDetail = {
    path: '/shop/SettleAccountsDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/settleAccounts/settle-accounts-detail').default);
        }, "SettleAccountsDetail")
    }
};
// 返款账户明细
export const BackAccountDetail = {
    path: '/shop/BackAccountDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/settleAccounts/back-account-detail').default);
        }, "BackAccountDetail")
    }
};
// 预存款详情
export const DepositDetail = {
    path: '/shop/DepositDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/deposit/deposit-detail').default);
        }, "DepositDetail")
    }
};
// 预存款充值
export const DepositRecharge = {
    path: '/shop/DepositRecharge',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/deposit/deposit-recharge').default);
        }, "DepositRecharge")
    }
};
// 预存款充值结果
export const DepositRechargeResult = {
    path: '/shop/DepositRechargeResult',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/deposit/deposit-recharge-result').default);
        }, "DepositRechargeResult")
    }
};

export const OrderStatistics = {
    path: '/shop/OrderStatistics',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-statistics').default);
        }, "OrderStatistics")
    }
};
export const OrderStatisticsDetail = {
    path: '/shop/OrderStatisticsDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-statistics-detail').default);
        }, "OrderStatisticsDetail")
    }
};
// 分享设置
export const ShareSetting = {
    path: '/shop/ShareSetting',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/share-setting').default);
        }, "ShareSetting")
    }
};

//商城首页
export const Integral = {
    path: '/shop/integral',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral'));
        }, 'Integral')
    }
};
//商城首页
export const IntegralList = {
    path: '/shop/IntegralList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-list'));
        }, 'IntegralList')
    }
};
//积分商品详情
export const IntegralDetail = {
    path: '/shop/IntegralDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-detail'));
        }, 'IntegralDetail')
    }
};
//积分明细
export const IntegralFlow = {
    path: '/shop/IntegralFlow',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-flow'));
        }, 'IntegralFlow')
    }
};
//赚积分
export const IntegralRule = {
    path: '/shop/IntegralRule',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-rule'));
        }, 'IntegralRule')
    }
};
//赚积分规则
export const IntegralRuleDetail = {
    path: '/shop/IntegralRuleDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-rule-detail'));
        }, 'IntegralRuleDetail')
    }
};
//订单确认
export const IntegralOrderCreate = {
    path: '/shop/IntegralOrderCreate',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-order-create'));
        }, 'IntegralOrderCreate')
    }
};
//积分商城订单列表
export const IntegralOrder = {
    path: '/shop/IntegralOrder',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-order'));
        }, 'IntegralOrder')
    }
};
//积分商城订单详情
export const IntegralOrderDetail = {
    path: '/shop/IntegralOrderDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-order-detail'));
        }, 'IntegralOrderDetail')
    }
};
//积分商城订单跟踪
export const IntegralLogistics = {
    path: '/shop/IntegralLogistics',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-logistics'));
        }, 'IntegralLogistics')
    }
};
//积分商城签到有礼
export const IntegralSign = {
    path: '/shop/IntegralSign',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/integral/integral-sign'));
        }, 'IntegralSign')
    }
};

// 退货申请
export const RefundApply = {
    path: '/shop/RefundApply',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/refund/refund-apply').default);
        }, 'RefundApply')
    }
};
// 退货申请-结果页
export const RefundResult = {
    path: '/shop/RefundResult',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/refund/refund-result').default);
        }, 'RefundResult')
    }
};
// 退货申请-列表页
export const RefundList = {
    path: '/shop/RefundList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/refund/refund-list').default);
        }, 'RefundList')
    }
};
// 退货申请-详情页
export const RefundDetail = {
    path: '/shop/RefundDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/refund/refund-detail').default);
        }, 'RefundDetail')
    }
};
// 退货申请-商品页
export const RefundProduct = {
    path: '/shop/RefundProduct',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/refund/refund-product').default);
        }, 'RefundProduct')
    }
};
// 合并支付
export const CombinedPay = {
    path: '/shop/CombinedPay',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/combined-pay').default);
        }, 'CombinedPay')
    }
};
// 合并支付成功
export const CombinedPaySuccess = {
    path: '/shop/CombinedPaySuccess',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/combined-pay-success').default);
        }, 'CombinedPaySuccess')
    }
};
// 销售中心
export const DistributionHome = {
    path: '/shop/DistributionHome',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/distribution-home').default);
        }, 'DistributionHome')
    }
};
// 业绩统计
export const PerformanceStatistics = {
    path: '/shop/PerformanceStatistics',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/performance-statistics').default);
        }, 'PerformanceStatistics')
    }
};
// 客户统计
export const ClientStatistics = {
    path: '/shop/ClientStatistics',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/client-statistics').default);
        }, 'ClientStatistics')
    }
};
// 订单统计
export const ClientOrderStatistics = {
    path: '/shop/ClientOrderStatistics',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/order-statistics').default);
        }, 'ClientOrderStatistics')
    }
};
// 推广商品
export const GeneralizeGoods = {
    path: '/shop/GeneralizeGoods',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/generalize-goods').default);
        }, 'GeneralizeGoods')
    }
};
// 结算中心
export const SettlementHome = {
    path: '/shop/SettlementHome',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/settlement-home').default);
        }, 'SettlementHome')
    }
};
// 提现
export const WithdrawDeposit = {
    path: '/shop/WithdrawDeposit',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/withdraw-deposit').default);
        }, 'WithdrawDeposit')
    }
};
// 提现账户
export const WithdrawAccount = {
    path: '/shop/WithdrawAccount',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/withdraw-account').default);
        }, 'WithdrawAccount')
    }
};
// 收支明细
export const AccountLog = {
    path: '/shop/AccountLog',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/account-log').default);
        }, 'AccountLog')
    }
};
// 提现记录
export const WithdrawLog = {
    path: '/shop/WithdrawLog',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/withdraw-log').default);
        }, 'WithdrawLog')
    }
};
// 加盟落地页
export const JoinHome = {
    path: '/join',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/join-home').default);
        }, 'JoinHome')
    }
};
// 邀请卡
export const InvitationHome = {
    path: '/shop/InvitationHome',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/invitation-home').default);
        }, 'InvitationHome')
    }
};
// 海报推广
export const PostersPromoting = {
    path: '/shop/PostersPromoting',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/distribution/posters-promoting').default);
        }, 'PostersPromoting')
    }
};
// 最近浏览
export const UserFootprint = {
    path: '/shop/UserFootprint',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-footprint').default);
        }, 'UserFootprint')
    }
};
// 扫码加入购物车
export const ScanToCart = {
    path: '/shop/ScanToCart',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/cart/scan-to-cart').default);
        }, 'ScanToCart')
    }
};
// 扫码加入购物车(ios兼容)
export const ScanToCartIos = {
    path: '/shop/shop/ScanToCart',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/cart/scan-to-cart').default);
        }, 'ScanToCartIos')
    }
};
// 串号扫码
export const GoodsSnScan = {
    path: '/shop/GoodsSnScan',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods-sn/goods-sn-scan').default);
        }, 'GoodsSnScan')
    }
};
// 代金券
export const VouchersList = {
    path: '/shop/VouchersList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/vouchers/vouchers-list').default);
        }, "VouchersList")
    }
};
export const VouchersDetail = {
    path: '/shop/VouchersDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/vouchers/vouchers-detail').default);
        }, "VouchersDetail")
    }
};
export const ExperienceList = {
    path: '/shop/ExperienceList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/experience/experience-list').default);
        }, "ExperienceList")
    }
};
export const ExperienceDetail = {
    path: '/shop/ExperienceDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/experience/experience-detail').default);
        }, "ExperienceDetail")
    }
};
// 定制首页
export const Custom = {
    path: '/shop/Custom',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/custom/custom').default);
        }, "Custom")
    }
};
// 定制搜索
export const CustomSearch = {
    path: '/shop/Custom/Search',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/custom/custom-search').default);
        }, "CustomSearch")
    }
};
// 定制规格
export const CustomGoods = {
    path: '/shop/Custom/Goods',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/custom/custom-goods').default);
        }, "CustomGoods")
    }
};

// 语言设置(未使用)
export const LangSetting = {
    path: '/shop/LangSetting',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-lang-setting').default);
        }, "LangSetting")
    }
};

// 申请授信
export const ClientCreditApply = {
    path: '/shop/ClientCreditApply',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/client-credit-apply').default);
        }, "ClientCreditApply")
    }
};

// 授信管理
export const ClientCreditList = {
    path: '/shop/ClientCreditList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/client-credit-list').default);
        }, "ClientCreditList")
    }
};
// 授信管理
export const ClientCreditContract = {
    path: '/shop/ClientCreditContract',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/client-credit-contract').default);
        }, "ClientCreditContract")
    }
};
// 发票管理
export const InvoiceAssistantList = {
    path: '/shop/InvoiceAssistantList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/invoice-assistant-list').default);
        }, "InvoiceAssistantList")
    }
};
// 发票管理
export const InvoiceAssistantDetail = {
    path: '/shop/InvoiceAssistantDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/invoice-assistant-detail').default);
        }, "InvoiceAssistantDetail")
    }
};

// 串号查询
export const GoodsSnVerifyRecord = {
    path: '/shop/VerifyRecord',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods-sn/verify-record-list').default);
        }, "GoodsSnVerifyRecord")
    }
};

// 串号查询
export const GoodsSnSearch = {
    path: '/shop/GoodsSnSearch',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods-sn/goods-sn-search').default);
        }, "GoodsSnSearch")
    }
};

export const GoodsSnVerify = {
    path: '/shop/GoodsSnVerify',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/goods-sn/goods-sn-verify').default);
        }, "GoodsSnVerify")
    }
};

// 账号注销
export const UserLogOff = {
    path: '/shop/UserLogOff',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-log-off').default);
        }, "UserLogOff")
    }
};
// 存货管理
export const ConsignGoodsList = {
    path: '/shop/ConsignGoodsList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/consign-goods/consign-list').default);
        }, "ConsignGoodsList")
    }
};
// 存货
export const ConsignStock = {
    path: '/shop/ConsignStock',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/consign-goods/consign-stock').default);
        }, "ConsignStock")
    }
};
// 提货
export const ConsignPickUp = {
    path: '/shop/ConsignPickUp',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/consign-goods/consign-pickUp').default);
        }, "ConsignPickUp")
    }
};
// 提货记录
export const ConsignPickUpRecord = {
    path: '/shop/ConsignPickUpRecord',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/consign-goods/consignPickUp-list').default);
        }, "ConsignPickUpRecord")
    }
};
// 提货申请
export const ConsignPickUpSuccess = {
    path: '/shop/ConsignPickUpSuccess',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/consign-goods/consignPickUp-success').default);
        }, "ConsignPickUpSuccess")
    }
};
// 提货单详情
export const ConsignPickUpDetail = {
    path: '/shop/ConsignPickUpDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/consign-goods/consignPickUp-detail').default);
        }, "ConsignPickUpDetail")
    }
};
// 子账户
export const UserSubAccount = {
    path: '/shop/UserSubAccount',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-sub-account').default);
        }, 'UserSubAccount')
    }
};
// 员工推广
export const EmployeePromotion = {
    path: '/shop/EmployeePromotion',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/employe-promotion').default);
        }, "EmployeePromotion")
    }
};
// 铺货上报
export const DistributionReport = {
    path: '/shop/DistributionReport',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/distributio-report').default);
        }, "DistributionReport")
    }
};
export const UserCredit = {
    path: '/shop/UserCredit',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-credit'));
        }, "UserCredit")
    }
};
export const UserQuotationList = {
    path: '/shop/UserQuotationList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-quotation-list'));
        }, "UserQuotationList")
    }
};
export const CustomerServiceCenter = {
    path: '/user/ServiceCenter',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/customer-service-center-route').default);
        }, 'CustomerServiceCenter')
    },
};
export const UserMessage = {
    path: '/shop/UserMessage',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-message').default);
        }, 'UserMessage')
    },
};
export const UserCooperate = {
    path: '/shop/UserCooperate',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-cooperate'));
        }, "UserCooperate")
    }
};
export const JoinApply = {
    path: '/shop/JoinApply',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/join-apply'));
        }, "JoinApply")
    }
};
export const CooperateApply = {
    path: '/shop/CooperateApply',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/cooperate-apply'));
        }, "CooperateApply")
    }
};

// 防伪码查询
export const SecurityCodeSearch = {
    path: '/shop/SecurityCodeSearch',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/security-code/security-code-search').default);
        }, "SecurityCodeSearch")
    }
};

export const SecurityCodeScan = {
    path: '/shop/SecurityCodeScan',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/security-code/security-code-scan').default);
        }, "SecurityCodeScan")
    }
};

export const UserInquiry = {
    path: '/shop/UserInquiry',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/user/user-inquiry'));
        }, "UserInquiry")
    }
};

export const MyBargainList = {
    path: '/shop/MyBargainList',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/bargain/bargain-list').default);
        }, "MyBargainList")
    }
};

export const MyBargainDetail = {
    path: '/shop/MyBargainDetail',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/bargain/bargain-detail').default);
        }, "MyBargainDetail")
    }
};

export const BargainHelp = {
    path: '/shop/BargainHelp',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/bargain/bargain-help').default);
        }, "BargainHelp")
    }
};

// 交易快照
export const OrderTradeSnapshot = {
    path: '/shop/OrderTradeSnapshot',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            return cb(null, require('../routes/order/order-trade-snapshot').default);
        }, "OrderTradeSnapshot")
    }
};

// 自提点选择
// export const PickUpStationList = {
//     path: '/user/PickUpStationList',
//     getComponent(nextState, cb) {
//         require.ensure([], (require) => {
//             return cb(null, require('../routes/user/pick-up-station-list').default);
//         }, "PickUpStationList")
//     }
// };




// WEBPACK FOOTER //
// ./src/config/route-config.js